const REDACTED_VALUE = "[REDACTED]";

const sensitiveKeyPattern =
	/^(authorization|cookie|set-cookie|x-api-key|api-key|access-token|refresh-token|id-token|token|jwt)$/i;

const isSensitiveKey = (key: string) =>
	sensitiveKeyPattern.test(key) || /token$/i.test(key);

const getCircularReplacer = () => {
	const seen = new WeakSet<object>();

	return (key: string, value: unknown) => {
		if (isSensitiveKey(key)) {
			return REDACTED_VALUE;
		}

		if (value instanceof Error) {
			return {
				name: value.name,
				message: value.message,
				stack: value.stack,
				...Object.fromEntries(Object.entries(value)),
			};
		}

		if (typeof value === "bigint") {
			return value.toString();
		}

		if (typeof value === "function") {
			return `[Function ${value.name || "anonymous"}]`;
		}

		if (value && typeof value === "object") {
			if (seen.has(value)) {
				return "[Circular]";
			}
			seen.add(value);
		}

		return value;
	};
};

export const serializeErrorForSentry = (value: unknown) => {
	if (typeof value === "string") {
		return value;
	}

	try {
		const serialized = JSON.stringify(value, getCircularReplacer());
		return serialized ?? String(value);
	} catch (error) {
		return `Failed to serialize error payload: ${String(error)}`;
	}
};
